export default __webpack_public_path__ + "static/media/04_DAIF_Infra_02_end.7058157d.jpg";